module.exports = __webpack_public_path__ + "static/media/avatar2.485a9065.png";


//////////////////
// WEBPACK FOOTER
// ./src/avatars/avatar2.png
// module id = 36
// module chunks = 0